import DatabaseModel from './DatabaseModel.js';

// SPEC-DASHBOARD-CONTROL-PLANIFICACION: adapter del Dashboard de Control de Planificación.
// Todo solo-lectura salvo reasignar (camino canónico pedidoService.update en backend) e incidencias.
var ControlPlanificacion = Object.create(DatabaseModel);

ControlPlanificacion.model = 'planificacion/control';

// Agregados ($facet único): KPIs + donut + barras EST PLA + equipo + provincias + aviso fichas.
// data = { provincia?, planificable? (SI|NO|VACIO), planificadora?, materia?, desde?, hasta? }
// #544: `desde`/`hasta` son la ventana [desde, hasta) sobre la fecha de ejecución del pedido, la
// MISMA que acepta /anomalias — extremo `hasta` abierto, así que quien llama manda el día siguiente
// al último que quiere ver. Un rango al revés se contesta con un 400 en vez de con ceros.
// El aviso de fichas (inspectores sin ficha) NO sale de las líneas y no se filtra por fechas.
ControlPlanificacion.agregados = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/agregados',
        method: 'POST',
        data: params.data || {}
    }, false);
};

// Tabla de líneas: MISMOS filtros que agregados (ventana desde/hasta incluida) + estPla[] (chips)
// + texto + paginación.
// #326: devuelve `{lineas, resumen}`, no la lista a pelo. El `resumen` trae las cifras del conjunto
// ENTERO del filtro y la conclusión de recorte (`completitud`), derivadas en la MISMA consulta que la
// página: es lo que permite a la cabecera de la tabla decir el total y no la longitud de la página.
ControlPlanificacion.lineas = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/lineas',
        method: 'POST',
        data: params.data || {}
    }, false);
};

// PALANCA C FASE 2: anomalías a revisar (cobrado/facturado sin realizar + cerradas SAP), solo lectura.
// data = { inspector?, desde?, hasta?, incluirLineas?, limite?, estado?, pagina? } — vacío = ámbito
// global, solo totales.
// Los totales (tarjetas y chips) NO llevan tope ni se enteran del `estado`: son siempre los del
// conjunto entero, y por eso no cambian al pulsar un chip. La lista sí lleva tope, y con
// `incluirLineas` viene además `lineasResumen` con la conclusión de recorte (#326).
// #543: `estado` acota la lista al estado dominante del chip y `pagina` la recorre («Cargar más»).
// #544: el dashboard manda aquí la MISMA ventana `desde`/`hasta` que a /agregados y /lineas — es la
// única parte del filtro de cabecera que llega a esta sección, y es lo que impide que las tarjetas
// cuenten un conjunto distinto del de las cifras de arriba.
// `lineasResumen` habla de lo ACUMULADO —páginas 0..N, no la última suelta—, que es lo que hace que
// la frase de recorte desaparezca cuando ya se ven todas.
ControlPlanificacion.anomalias = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/anomalias',
        method: 'POST',
        data: params.data || {}
    }, false);
};

// Catálogo EST PLA (configcombo "EST PLA"): chips y select de reasignación.
ControlPlanificacion.catalogoEstPla = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/catalogo-estpla',
        method: 'GET',
        data: {}
    }, false);
};

// #325 (opción A, 08/10/2026): AQUÍ NO HAY consulta del total de no-planificables, y es a propósito.
// La hubo —el panel del calendario pedía la lista al Proponer y el total a
// `/planificacion/control/total-no-planificables`— y comparar las dos lecturas agotó cuatro rondas de
// revisión: no coincidían en el dedup del espejo, la copia elegida, el importe, el minuto de retraso
// del caché, el orden ni el tope. Dirección cerró la familia eligiendo que el total viaje CON la lista
// en la respuesta del Proponer (`ProponerResponseDTO.bloqueadosNegocioResumen`). El endpoint sigue
// publicado en la API para cualquier otro consumidor, pero el front no lo llama: añadir aquí una
// segunda lectura del mismo universo es reabrir la familia.

// Reasigna EST PLA en lote (backend agrupa por pedido y pasa por pedidoService.update: histórico,
// usuario/fecha, acción automática del catálogo y ChangeStream). data = { lineas:[{idPedido,numLinea}], valor, notas? }
ControlPlanificacion.reasignarEstPla = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/reasignar-estpla',
        method: 'POST',
        data: params.data
    }, false);
};

// Envía las líneas seleccionadas a Incidencias de planificación (dedup por clave en backend).
ControlPlanificacion.enviarIncidencias = function(params) {
    var self = this;
    params = params || {};
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/enviar-incidencias',
        method: 'POST',
        data: params.data
    }, false);
};

export default ControlPlanificacion;
